import React, { Component } from "react";

class PendingPatientListItem extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { complain_type_id,
      coordinate_x,
      coordinate_y,
      created_at,
      date_of_birth,
      department_id,
      email,
      exported_file_path,
      first_name,
      gender,
      id,
      image_view,
      last_name,
      narrative_summary,
      patient_additional_info,
      phone,
      status,
      submitted_by_patient,
      complain_types,
      surgeon_id,
      title,
      updated_at,
      via_surgeon_id } = this.props.pendingPatientsData;

    return (
      <React.Fragment>
        <li onClick={this.props.handleAction.bind(this, id)}>
          <div className="row">
            <div className="col-md-5 col-sm-12">
              <div className="sypmtom-info">
                <div className="symptom-img">
                  <img src={require(`../../../assets/img/icons/ic-patient-img.png`)} alt="" />
                </div>
                <div className="symptom-title">
                  <h2>
                    {complain_types}<span>{first_name} {last_name}</span>
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-12">
              <div className="symptom-date">
                <p>{created_at}</p>
              </div>
            </div>
            <div className="col-md-4 col-sm-12">
              <div className="symptom-state">
                <p>
                  { status==0 
                    ?
                      <img src={require(`../../../assets/img/icons/ic-waiting.png`)} alt="" /> 
                    : <img src={require(`../../../assets/img/icons/ic-complete-native.png`)} height="18" alt="" />
                  }
                  { status==1 
                    ?
                     'Approved'
                    : 'Waiting for Approval'
                  }
                  
                </p>
              </div>
            </div>
          </div>
        </li>
      </React.Fragment>
    );
  }
}

export default PendingPatientListItem;
